// Scorecard v2 chip strip. Renders one chip per active side game running
// on the current round/group, each chip showing a game-specific status
// snippet. Empty state renders nothing (zero height) so the base landing
// leaves the scorecard visually untouched until a game populates it.
//
// Contract with the game chunks (Wolf, Shuffle, Dots, etc.): each chunk
// contributes chip data by pushing an entry into the `chips` array the
// consumer passes in. Chip anatomy per docs/scorecard-v2.md:
//   { key: string, glyph: node|string, label: string, status?: string,
//     tone?: 'default' | 'wolf' | 'shuffle-diamond' | 'shuffle-heart' | ... }
//
// Tap on chip → `onChipTap(key)`. Consumer decides what to open (game
// detail view, Shuffle history modal, etc.).

const TONE_STYLES = {
  default:          { bg: 'var(--green-dark)', border: 'var(--green-mid)', fg: 'var(--cream)' },
  wolf:             { bg: 'var(--green-dark)', border: 'var(--gold)',      fg: 'var(--gold)'  },
  'shuffle-spade':  { bg: '#1a1a1a',           border: '#3a3a3a',          fg: '#e8e8e8'      },
  'shuffle-club':   { bg: '#0f2418',           border: '#1e4732',          fg: '#7dd3a8'      },
  'shuffle-diamond':{ bg: '#2a1416',           border: '#5a2830',          fg: '#f88a92'      },
  'shuffle-heart':  { bg: '#2a1416',           border: '#5a2830',          fg: '#f88a92'      },
  dots:             { bg: 'var(--green-dark)', border: 'var(--gold)',      fg: 'var(--cream)' },
}

export default function ScorecardChipStrip({ chips = [], onChipTap }) {
  if (!chips || chips.length === 0) return null
  return (
    <div style={{
      display: 'flex', gap: 6, overflowX: 'auto',
      marginBottom: 8, paddingBottom: 2,
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
    }}>
      {chips.map(chip => {
        const tone = TONE_STYLES[chip.tone] || TONE_STYLES.default
        return (
          <button
            key={chip.key}
            onClick={() => onChipTap?.(chip.key)}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              padding: '4px 10px', borderRadius: 999,
              background: tone.bg, border: `1px solid ${tone.border}`, color: tone.fg,
              fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.02em',
              cursor: onChipTap ? 'pointer' : 'default',
              flexShrink: 0, whiteSpace: 'nowrap',
            }}
          >
            {chip.glyph != null && (
              <span aria-hidden="true" style={{ fontSize: '0.85rem', lineHeight: 1 }}>{chip.glyph}</span>
            )}
            <span>{chip.label}</span>
            {chip.status && (
              <span style={{ opacity: 0.75, fontWeight: 400 }}>· {chip.status}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}
